// src/router/authGuards.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const getToken = () => localStorage.getItem("authToken") || localStorage.getItem("token");
export const isAuthenticated = () => !!getToken();


const DEFAULT_SIGNIN = "/pos/signin";
const DEFAULT_AFTER_LOGIN = "/pos";

export function RequireAuth() {
  const location = useLocation();
  return isAuthenticated() ? (
    <Outlet />
  ) : (
    <Navigate to={DEFAULT_SIGNIN} replace state={{ from: location }} />
  );
}

export function PublicOnly() {
  return isAuthenticated() ? (
    <Navigate to={DEFAULT_AFTER_LOGIN} replace />
  ) : (
    <Outlet />
  );
}
